export default (agency_id, token, merchant_type, parentStoreStatus, action) => {

  const xhr = new XMLHttpRequest()
  xhr.open('GET', '/api/v1/agency_infos/' + agency_id)
  xhr.setRequestHeader( 'X-CSRF-Token', token)
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send()
  xhr.addEventListener('load', function(result) {
    if (result.currentTarget.status == 200) {
      if (result.currentTarget.responseText.length == 0) {
          return
      }
      const json = JSON.parse(result.currentTarget.responseText)

      const cardCompanies = merchant_type === "store"? json.agency_store_card_companies : json.agency_dental_card_companies;
      const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]');
      const nestedFields = document.getElementsByClassName('parent_store_card_company_nested_fields');

      const eMoneyCompanies = merchant_type === "store"? json.agency_store_e_money_companies : json.agency_dental_e_money_companies;
      const addEMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]');
      const eMoneyNestedFields = document.getElementsByClassName('parent_store_e_money_company_nested_fields');

      const qrCompanies = merchant_type === "store"? json.agency_store_qr_code_companies : json.agency_dental_qr_code_companies;
      const addQrNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]');
      const qrNestedFields = document.getElementsByClassName('parent_store_qr_code_company_nested_fields');

      const directDebitCompanies = merchant_type === "store"? json.agency_store_direct_debit_companies : json.agency_dental_direct_debit_companies;
      const addDirectDebitNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#direct-debit-destination-form"]');
      const directDebitNestedFields = document.getElementsByClassName('parent_store_direct_debit_company_nested_fields');

      if (action === "load") {
        if(nestedFields.length === 0 &&
            eMoneyNestedFields.length === 0 &&
            qrNestedFields.length === 0 &&
            directDebitNestedFields.length === 0) {
          // 連携先(クレジットカード)処理
          reflectAgencyBrandSettings('creditCard', cardCompanies, nestedFields, addNestedFieldsBtn);
          // 連携先(電子マネー)処理
          reflectAgencyBrandSettings('eMoney', eMoneyCompanies, eMoneyNestedFields, addEMoneyNestedFieldsBtn);
          // 連携先(QRコード)処理
          reflectAgencyBrandSettings('qrCode', qrCompanies, qrNestedFields, addQrNestedFieldsBtn);
          // 連携先(口座引落)処理
          reflectAgencyBrandSettings('directDebit', directDebitCompanies, directDebitNestedFields, addDirectDebitNestedFieldsBtn);
        }
      } else if (action === "change") {
        if (parentStoreStatus == false) {
          reflectAgencyBrandSettingsOnChangeWithoutParentStore('creditCard', cardCompanies, nestedFields, addNestedFieldsBtn);
          reflectAgencyBrandSettingsOnChangeWithoutParentStore('eMoney', eMoneyCompanies, eMoneyNestedFields, addEMoneyNestedFieldsBtn);
          reflectAgencyBrandSettingsOnChangeWithoutParentStore('qrCode', qrCompanies, qrNestedFields, addQrNestedFieldsBtn);
          reflectAgencyBrandSettingsOnChangeWithoutParentStore('directDebit', directDebitCompanies, directDebitNestedFields, addDirectDebitNestedFieldsBtn);
        }

        // When the store has some connection, Parent Store is set, and the Agency is changed.
        if (parentStoreStatus == true) {
          reflectAgencyBrandSettingsOnChangeWithParentStore('creditCard', cardCompanies, nestedFields);
          reflectAgencyBrandSettingsOnChangeWithParentStore('eMoney', eMoneyCompanies, eMoneyNestedFields);
          reflectAgencyBrandSettingsOnChangeWithParentStore('qrCode', qrCompanies, qrNestedFields);
          reflectAgencyBrandSettingsOnChangeWithParentStore('directDebit', directDebitCompanies, directDebitNestedFields);
        }
      }
    } else if (result.currentTarget.status == 404) {
      alert(result.currentTarget.responseText)
    } else {
      alert("API取得でエラーが発生しました")
    }
  })
};

class AgencyBrandSettingParams {
  company_id_column_name = '';

  cardCompanyElmsClassName = '';
  ratioElmsClassName = '';
  agencyRatioElmsClassName = '';
  wholesaleRatioElmsClassName = '';
  brandIdElmsClassName = '';

  cardCompanyCssSelector = '';
  ratioCssSelector = '';
  agencyRatioCssSelector = '';
  wholesaleCssSelector = '';
  brandIdCssSelector = '';

  constructor(mode) {
    switch(mode) {
      case 'creditCard':
        this.company_id_column_name = 'card_company_id';
        this.pk_column_name = 'store_card_company_id';

        this.cardCompanyElmsClassName = 'parent_store_card_company';
        this.ratioElmsClassName = 'parent_store_ratio';
        this.agencyRatioElmsClassName = 'parent_store_agency_sales_ratio';
        this.wholesaleRatioElmsClassName = 'parent_store_wholesale_ratio';
        this.brandIdElmsClassName = 'parent_store_brand';

        this.cardCompanyCssSelector = '.parent_store_card_company';
        this.ratioCssSelector = '.parent_store_ratio';
        this.agencyRatioCssSelector = '.parent_store_agency_sales_ratio';
        this.wholesaleRatioCssSelector = '.parent_store_wholesale_ratio';
        this.brandIdCssSelector = '.parent_store_brand';
        break;
      case 'eMoney':
        this.company_id_column_name = 'e_money_company_id';
        this.pk_column_name = 'store_e_money_company_id';

        this.cardCompanyElmsClassName = 'parent_store_e_money_company';
        this.ratioElmsClassName = 'parent_store_e_money_ratio';
        this.agencyRatioElmsClassName = 'parent_store_e_money_agency_sales_ratio';
        this.wholesaleRatioElmsClassName = 'parent_store_e_money_wholesale_ratio';
        this.brandIdElmsClassName = 'parent_store_e_money_brand';

        this.cardCompanyCssSelector = '.parent_store_e_money_company';
        this.ratioCssSelector = '.parent_store_e_money_ratio';
        this.agencyRatioCssSelector = '.parent_store_e_money_agency_sales_ratio';
        this.wholesaleRatioCssSelector = '.parent_store_e_money_wholesale_ratio';
        this.brandIdCssSelector = '.parent_store_e_money_brand';
        break;
      case 'qrCode':
        this.company_id_column_name = 'qr_code_company_id';
        this.pk_column_name = 'store_qr_code_company_id';

        this.cardCompanyElmsClassName = 'parent_store_qr_code_company';
        this.ratioElmsClassName = 'parent_store_qr_code_ratio';
        this.agencyRatioElmsClassName = 'parent_store_qr_code_agency_sales_ratio';
        this.wholesaleRatioElmsClassName = 'parent_store_qr_code_wholesale_ratio';
        this.brandIdElmsClassName = 'parent_store_qr_code_brand';

        this.cardCompanyCssSelector = '.parent_store_qr_code_company';
        this.ratioCssSelector = '.parent_store_qr_code_ratio';
        this.agencyRatioCssSelector = '.parent_store_qr_code_agency_sales_ratio';
        this.wholesaleRatioCssSelector = '.parent_store_qr_code_wholesale_ratio';
        this.brandIdCssSelector = '.parent_store_qr_code_brand';
        break;
      case 'directDebit':
        this.company_id_column_name = 'direct_debit_company_id';
        this.pk_column_name = 'store_direct_debit_company_id';

        this.cardCompanyElmsClassName = 'parent_store_direct_debit_company';
        this.ratioElmsClassName = 'parent_store_direct_debit_ratio';
        this.agencyRatioElmsClassName = 'parent_store_direct_debit_agency_sales_ratio';
        this.wholesaleRatioElmsClassName = 'parent_store_direct_debit_wholesale_ratio';
        this.brandIdElmsClassName = 'parent_store_direct_debit_brand';

        this.cardCompanyCssSelector = '.parent_store_direct_debit_company';
        this.ratioCssSelector = '.parent_store_direct_debit_ratio';
        this.agencyRatioCssSelector = '.parent_store_direct_debit_agency_sales_ratio';
        this.wholesaleRatioCssSelector = '.parent_store_direct_debit_wholesale_ratio';
        this.brandIdCssSelector = '.parent_store_direct_debit_brand';
        break;
      default:
        alert('実装エラー');
    }
  }
}

const reflectAgencyBrandSettings = (mode, cardCompanies, nestedFields, addNestedFieldsBtn) => {
  const param = new AgencyBrandSettingParams(mode);

  for(let i = 0; i < cardCompanies.length; i++) {
    addNestedFieldsBtn.click();
  }

  const cardCompanyElms = document.getElementsByClassName(param.cardCompanyElmsClassName);
  for(let i = 0; i < cardCompanyElms.length; i++) {
    cardCompanyElms[i].value = cardCompanies[i][param.company_id_column_name];
    cardCompanyElms[i].classList.add('parent_store_item');
  }
  const ratioElms = document.getElementsByClassName(param.ratioElmsClassName);
  for(let i = 0; i < ratioElms.length; i++) {
    ratioElms[i].value = cardCompanies[i].ratio;
    ratioElms[i].classList.add('parent_store_item');
  }
  const agencyRatioElms = document.getElementsByClassName(param.agencyRatioElmsClassName);
  for(let i = 0; i < agencyRatioElms.length; i++) {
    agencyRatioElms[i].value = cardCompanies[i].agency_sales_ratio;
    agencyRatioElms[i].classList.add('parent_store_item');
  }
  const wholesaleRatioElms = document.getElementsByClassName(param.wholesaleRatioElmsClassName);
  for(let i = 0; i < wholesaleRatioElms.length; i++) {
    wholesaleRatioElms[i].value = cardCompanies[i].wholesale_ratio;
    wholesaleRatioElms[i].classList.add('parent_store_item');
  }
  const brandIdElms = document.getElementsByClassName(param.brandIdElmsClassName);
  for(let i = 0; i < brandIdElms.length; i++) {
    brandIdElms[i].value = cardCompanies[i].brand_id;
    brandIdElms[i].classList.add('parent_store_item');
  }
}

const reflectAgencyBrandSettingsOnChangeWithoutParentStore = (mode, cardCompanies, nestedFields, addNestedFieldsBtn) => {
  const param = new AgencyBrandSettingParams(mode);

  const tmpCardCompanies = cardCompanies;
  loopTop:
      for(let i = 0; i < nestedFields.length; i++) {
        const nestedField = nestedFields[i];
        const nestedFieldsHiddenElm = nestedField.querySelector("input[type='hidden']");
        const cardCompanyElm = nestedField.querySelector(param.cardCompanyCssSelector);
        const ratioElm = nestedField.querySelector(param.ratioCssSelector);
        const agencyRatioElm = nestedField.querySelector(param.agencyRatioCssSelector);
        const wholesaleRatioElm = nestedField.querySelector(param.wholesaleRatioCssSelector);
        const brandIdElm = nestedField.querySelector(param.brandIdCssSelector);
        const recordIdElm = nestedField.querySelector(`input[type="hidden"][name$="[${param.pk_column_name}]"]`);
        const originalId = recordIdElm && recordIdElm.dataset ? recordIdElm.dataset.originalId : null;
        const hasRecordInDB = originalId && !isNaN(Number(originalId));

        for(let j = 0; j < cardCompanies.length; j++) {
          if(cardCompanyElm.value === cardCompanies[j][param.company_id_column_name].toString()) {
            nestedField.style.display = null;
            nestedFieldsHiddenElm.value = false;
            ratioElm.value = cardCompanies[j].ratio;
            agencyRatioElm.value = cardCompanies[j].agency_sales_ratio;
            if (!hasRecordInDB) {
              wholesaleRatioElm.value = cardCompanies[j].wholesale_ratio;
            }
            brandIdElm.value = cardCompanies[j].brand_id;
            tmpCardCompanies.splice(j, 1);
            continue loopTop;
          }
        }
        const nextElm = nestedField.nextElementSibling;
        if(nextElm != null && nextElm.tagName === 'INPUT') {
          nestedField.style.display = 'none';
          nestedFieldsHiddenElm.value = 1;
        } else {
          nestedField.remove();
          i--;
        }
      }
  for(let i = 0; i < tmpCardCompanies.length; i++) {
    addNestedFieldsBtn.click();
    const cardCompanyElms = document.getElementsByClassName(param.cardCompanyElmsClassName);
    cardCompanyElms[cardCompanyElms.length-1].value = tmpCardCompanies[i][param.company_id_column_name];
    cardCompanyElms[cardCompanyElms.length-1].classList.add('parent_store_item');
    const ratioElms = document.getElementsByClassName(param.ratioElmsClassName);
    ratioElms[ratioElms.length-1].value = tmpCardCompanies[i].ratio;
    ratioElms[ratioElms.length-1].classList.add('parent_store_item');
    const agencyRatioElms = document.getElementsByClassName(param.agencyRatioElmsClassName);
    agencyRatioElms[agencyRatioElms.length-1].value = tmpCardCompanies[i].agency_sales_ratio;
    agencyRatioElms[agencyRatioElms.length-1].classList.add('parent_store_item');
    const wholesaleRatioElms = document.getElementsByClassName(param.wholesaleRatioElmsClassName);
    wholesaleRatioElms[wholesaleRatioElms.length-1].value = tmpCardCompanies[i].wholesale_ratio;
    wholesaleRatioElms[wholesaleRatioElms.length-1].classList.add('parent_store_item');
    const brandIdElms = document.getElementsByClassName(param.brandIdElmsClassName);
    brandIdElms[brandIdElms.length-1].value = tmpCardCompanies[i].brand_id;
    brandIdElms[brandIdElms.length-1].classList.add('parent_store_item');
  }
}

const reflectAgencyBrandSettingsOnChangeWithParentStore = (mode, cardCompanies, nestedFields) => {
  const param = new AgencyBrandSettingParams(mode);

  loopTop:
      for(let i = 0; i < nestedFields.length; i++) {
        const nestedField = nestedFields[i];
        const brandIdElm = nestedField.querySelector(param.brandIdCssSelector);
        brandIdElm.value = 0;
        continue loopTop;
      }

  loopTop:
      for(let i = 0; i < nestedFields.length; i++) {
        const nestedField = nestedFields[i];
        const cardCompanyElm = nestedField.querySelector(param.cardCompanyCssSelector);
        const brandIdElm = nestedField.querySelector(param.brandIdCssSelector);
        for(let j = 0; j < cardCompanies.length; j++) {
          if(cardCompanyElm.value === cardCompanies[j][param.company_id_column_name].toString()) {
            brandIdElm.value = cardCompanies[j].brand_id;
            continue loopTop;
          }
        }
      }
}
